import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { useTheme } from '../../../../../theming/useTheme';
import { ChevronIcon, Directions } from '../ChevronIcon';
import { DropDownMenu } from '../DropDownMenu';
import { Span, semanticCSS } from '../../../../../typography/semanticTags';
import { SemanticTagThemeProps } from '../../../../../typography/semanticTags/semanticTags.utils';
import { NavigationLink } from '../primaryHeader/PrimaryHeader';

const componentConfigThemeKey = 'moreLinks';

export interface MoreLinksProps {
  moreLinksText: string;
  links: NavigationLink[];
  pagePath: string;
}

export interface MoreLinksThemeProps extends SemanticTagThemeProps {
  titleColor: string;
  menuBackground: string;
  linkColor: string;
  hoverColor: string;
  fontSize: TypographySize;
}

const getStyle = (theme: MoreLinksThemeProps) => {
  const { titleColor, menuBackground } = theme;

  return StyleSheet.create({
    wrapper: {
      position: 'relative',
      height: '100%',
      display: 'flex',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
    },
    buttonTitle: {
      color: titleColor,
      marginRight: '9px',
    },
    menuBody: {
      listStyle: 'none',
      width: '100%',
      position: 'absolute',
      backgroundColor: menuBackground,
    },
  });
};

export const MoreLinks: React.FunctionComponent<MoreLinksProps> = props => {
  const { moreLinksText, links, pagePath } = props;
  const themeProps = useTheme<MoreLinksThemeProps>(componentConfigThemeKey);
  const { fontSize } = themeProps;
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = React.useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);


  const style = getStyle(themeProps);
  const chevronDirection = isMenuOpen ? Directions.UP : Directions.DOWN;

  return (
    <div className={css(style.wrapper)}>
      <button type="button" className={css(style.button)} onClick={toggleMenu}>
        <Span styles={semanticCSS(style.buttonTitle)} fontSizeLarge={fontSize} fontSizeMedium={fontSize} fontSizeSmall={fontSize}>{moreLinksText}</Span>
        <ChevronIcon direction={chevronDirection} />
      </button>
      {
        isMenuOpen && <DropDownMenu configThemeKey="moreLinks" menuLinks={links} highlightActive activeEndpoint={pagePath} />
      }
    </div>
  );
};
